import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import { Button } from '@material-ui/core';
import ModalCustom from '../../components/common/modalCustom/modalCustom';

let useStyles = makeStyles(() => ({
    root: {
        width: 400,
        padding: '20px 10px',
        maxWidth: '95% ',
        textAlign: 'center',
        "@media(max-width : 500px)":{
            width:'95%'
         },
    },
    customButton: {
        backgroundColor: '#0B1742 !important',
        color: '#fff',
        margin: 'auto !important',
        minWidth: "162px !important",
        minHeight: "40px !important",
        marginTop: '10px !important',
    },
    images:{
        width:'100%'
    }
}))





const RegistrationRedirectModal = ({ open, setOpen }) => {

    let classes = useStyles()
    let url = open;

    return (

        <ModalCustom
            open={open}
            onClose={()=>setOpen(false)}
        >
            <div className={classes['root']}>
                <div>
                    <img src="/assets/images/Logo.png" alt="" className={classes['images']} />
                </div>
                <div>
                    <p>
                        کاربر گرامی، شما مشتری کارگزاری پویان نمی‌باشید. لطفاً برای ثبت درخواست خود، ابتدا در سامانه زیر ثبت‌نام نمایید.

                    </p>
                </div>
                <div className={classes['gridBtns']}>
                    <Button
                        className={classes.customButton}
                        variant="contained"
                        style={{ color: 'white' }}
                        href={'https://reg.pouyanbroker.ir/'}
                        target='_blank'
                    >
                        ثبت نام
                    </Button>
                </div>

            </div>
        </ModalCustom>

    )
}


export default RegistrationRedirectModal;